import { Form } from "react-bootstrap";
import { Link, useInRouterContext } from "react-router-dom";
import { CASH_SYMBOLS, securityPath } from "../lib/security";

/**
 * A symbol linking to its security page (APP-1486). Outside a router, as when
 * a table is rendered on its own, it is a plain link to the same path.
 */
const SecurityLink = ({
  symbol,
  description,
}: {
  symbol: string;
  description?: string;
}) => {
  const inRouter = useInRouterContext();
  if (CASH_SYMBOLS.includes(symbol)) {
    return "Cash";
  }
  return (
    <>
      {inRouter ? (
        <Link to={securityPath(symbol)}>{symbol}</Link>
      ) : (
        <a href={securityPath(symbol)}>{symbol}</a>
      )}
      <br />
      <Form.Text>{description}</Form.Text>
    </>
  );
};

export default SecurityLink;
